import React from "react";
import { styled } from "@glitz/react";
import { black, fontSize } from "../theme";

type DescriptionProps = {
  description: string;
};

const Description: React.FC<DescriptionProps> = ({ description }) => {
  return (
    <DescriptionWrapper>
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </DescriptionWrapper>
  );
};

const DescriptionWrapper = styled.div({
  fontSize: fontSize.s,
  color: black,
});

export default Description;
